const NAVIGATION_SELECTOR = '#container-first-image .fp-slidesNav ul'

export function initProjectItemsNavigation() {

  showNavigationArrows()
  window.addEventListener('resize', () => showNavigationArrows())

  // Only works with https://
  listenToMobileShareEvents()
}

// Keeps the currently active dot visible. Reads the real scroll position and dot
// geometry on every call (instead of predicting it ahead of time), so it self-heals
// even if the user just dragged the strip by hand, and always lands on a page made
// of whole dots so nothing is left cut off at the edge.
export function scrollActiveDotIntoView(index) {
  const navigation = document.querySelector(NAVIGATION_SELECTOR)
  const dot = navigation?.querySelectorAll('li')[index]
  const dotWidth = getDotWidth(navigation)

  if (!navigation || !dot || !dotWidth) return

  const maskRect = navigation.getBoundingClientRect()
  const dotRect = dot.getBoundingClientRect()
  const isFullyVisible = dotRect.left >= maskRect.left && dotRect.right <= maskRect.right

  if (isFullyVisible) return

  const dotsPerPage = Math.max(1, Math.floor(maskRect.width / dotWidth))
  const pageWidth = dotsPerPage * dotWidth
  const targetPage = Math.floor(index / dotsPerPage)

  animateScrollTo(navigation, targetPage * pageWidth)
}

function getDotWidth(navigation) {
  const dot = navigation?.querySelector('li')
  if (!dot) return 0

  const style = window.getComputedStyle(dot)
  return dot.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight)
}

// The visible strip's width comes from CSS (max-width: 55% / 450px) as a rough
// budget to leave room for the arrows around it. Snap it down here to the nearest
// whole multiple of a dot's real rendered width so a dot is never cut in half.
function sizeNavigationViewport(navigation) {
  const dotWidth = getDotWidth(navigation)
  if (!dotWidth) return

  navigation.style.width = ''
  const naturalWidth = navigation.clientWidth
  const dotsPerPage = Math.max(1, Math.floor(naturalWidth / dotWidth))

  navigation.style.width = `${dotsPerPage * dotWidth}px`
  navigation.style.marginLeft = 'auto'
  navigation.style.marginRight = 'auto'
}

function showNavigationArrows() {
  const navigation = document.querySelector(NAVIGATION_SELECTOR)

  if (!navigation)
    return

  document.querySelectorAll('#slide-nav-left, #slide-nav-right').forEach(el => el.remove())

  sizeNavigationViewport(navigation)

  const needsScroll = navigation.scrollWidth > navigation.clientWidth

  if (needsScroll) {
    const leftNavigationArrow = createNavigationArrow('left')
    const rightNavigationArrow = createNavigationArrow('right')

    navigation.parentElement.prepend(leftNavigationArrow)
    navigation.parentElement.appendChild(rightNavigationArrow)

    leftNavigationArrow.addEventListener('click', () => scrollHorizontal(navigation, 'left'))
    rightNavigationArrow.addEventListener('click', () => scrollHorizontal(navigation, 'right'))
  }
}

function createNavigationArrow(direction) {
  const arrow = document.createElement('img')
  arrow.id = `slide-nav-${direction}`
  arrow.src = `/icons/${direction}.svg`

  return arrow
}

// Derives the current page from the real scrollLeft (rounded, so it recovers even
// if a manual drag left it off-grid) and jumps exactly one whole page of dots,
// so arrow clicks always land back on a page boundary.
function scrollHorizontal(navigation, direction) {
  const dotWidth = getDotWidth(navigation)
  if (!dotWidth) return

  const dotsPerPage = Math.max(1, Math.floor(navigation.clientWidth / dotWidth))
  const pageWidth = dotsPerPage * dotWidth

  const currentPage = Math.round(navigation.scrollLeft / pageWidth)
  const maxPage = Math.max(0, Math.ceil((navigation.scrollWidth - navigation.clientWidth) / pageWidth))
  const targetPage = direction === 'left' ? currentPage - 1 : currentPage + 1
  const clampedPage = Math.min(Math.max(targetPage, 0), maxPage)

  animateScrollTo(navigation, clampedPage * pageWidth)
}

function animateScrollTo(navigation, scrollLeft) {
  $(navigation).stop(true)
  $(navigation).animate({ scrollLeft }, 400)
}

function listenToMobileShareEvents() {
  const shareButton = document.getElementById('share-btn')

  // Only works with https://
  shareButton?.addEventListener('click', () => {
    if (navigator.share) {
      navigator.share({
        title: document.title,
        text: 'Check out this awesome page!',
        url: window.location.href
      })
      .then(() => console.log('Content shared successfully'))
      .catch((error) => console.error('Error sharing content:', error));
    }
  })
}

// reCaptcha form submit
function onSubmit(token) {
  // Create hidden input with token
  const input = document.createElement("input")
  input.type = "hidden"
  input.name = "token"
  input.value = token

  document.getElementById("contact_form").appendChild(input)
  document.getElementById("contact_form").submit()
}